/* eslint-disable implicit-arrow-linebreak */
import dayjs from '../config/dayjs';
import { addMoneyWithCurrency } from './money';
import { DEBT_STATUS, EXPOSED_STATUS, FINISHED_STATUS } from '../constants/invoices';

export const getLatestDocumentFinanceState = (uniqueDocumentFinanceState) => {
  if (!uniqueDocumentFinanceState?.length) {
    return {};
  }
  return uniqueDocumentFinanceState.reduce(
    (prev, current) => (dayjs(current.eventTime) > dayjs(prev.eventTime) ? current : prev),
  );
};

export const invoicesTotalAmountWithIva = (invoices) =>
  invoices?.reduce((sum, curr) => addMoneyWithCurrency(sum, curr.amountWithIva), 0);

export const getOperatedInvoices = (invoices) =>
  invoices?.filter((invoice) => !FINISHED_STATUS.includes(invoice.status));

export const getFinishedInvoices = (invoices) =>
  invoices?.filter((invoice) => FINISHED_STATUS.includes(invoice.status));

export const getExposedInvoices = (invoices) =>
  invoices?.filter((invoice) => EXPOSED_STATUS.includes(invoice.status));

export const getDebtInvoices = (invoices) =>
  invoices?.filter((invoice) => DEBT_STATUS.includes(invoice.status));

export const isInvoiceOperatedOrExposed = (invoiceStatus) =>
  FINISHED_STATUS.includes(invoiceStatus) || EXPOSED_STATUS.includes(invoiceStatus);
